import React, { Component } from 'react';
import AuthContext from '../AuthContext';
import { Navigate, Outlet } from "react-router-dom";

export class AdminPanel extends Component {
    static contextType = AuthContext;

    render() {
        const { isAuthenticated, role, isChecked } = this.context;
        if (!isChecked)
            return;
        
        if (!isAuthenticated || role !== "admin") {
            return <Navigate to="/403" replace />;
        }

        return (
            <div className="min-h-full">
                <div className="row g-0">
                    <Outlet />
                </div>
            </div>
        );
    }
}
